import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import CONFIG from "../../constant/config";
let smallStyle: any = {
  transform: "scale(0.75)",
  transformOrigin: "0 0",
};
const Recaptcha = ({ touch, error, onChange }: any) => {
  return (
    <div>
      <ReCAPTCHA style={smallStyle} sitekey={CONFIG.RECAPTCHA_KEY || ""} onChange={onChange} />
      {error && <div>{error && <span className="error_message">{error}</span>}</div>}{" "}
    </div>
  );
};

export default Recaptcha;
